import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";
import styled from "styled-components";

import {
    domain,
    QualificationMetOrNot,
    Text,
    textWithLinks,
    useDeviceSize,
} from "../..";
import {
    EducationJobQualification,
    FileProcessingType,
    LeadEducationJobQualification,
} from "../../domain";
import { EducationJobTag } from "../../domain/educationJobTag";
import { baseColors, RelodeTheme } from "../styles";

const Line = styled.div`
    grid-column: 1 / span 3;
    height: 1px;
    border: 1px solid ${baseColors.border_gray};
`;

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            qualificationList: {
                display: "grid",
                gridTemplateColumns: "min-content 2fr 2fr",
                columnGap: 8,
                alignItems: "center",
            },
            tableHeader: {
                fontWeight: "bold",
                height: 56,
                display: "flex",
                alignItems: "center",
            },
            answerList: {
                display: "grid",
                gridTemplateColumns: "2fr 50%",
                gridColumn: "2 / span 2",
                rowGap: 4,
                columnGap: 10,
                marginBottom: 16,
                marginLeft: 10,
                [theme.breakpoints.down("md")]: {
                    marginTop: 16,
                    marginBottom: 16,
                },
            },
            answerText: {
                justifySelf: "left",
            },
            multiAnswerText: {
                justifySelf: "left",
            },
            stateListQuestion: {
                marginTop: 16,
                marginBottom: 16,
            },
            requirementText: {
                padding: theme.spacing(2, 0),
            },
            ampContainer: {
                paddingBottom: theme.spacing(2),
            },
            ampPlayerLabel: {
                marginBottom: theme.spacing(1),
            },
        }),
    { name: "CandidateJobQualifications" }
);

export const LeadJobQualificationsView = (props: {
    title: string;
    leadJobQualifications: domain.LeadJobQualifications;
    isRequired: boolean;
}) => {
    const { leadJobQualifications, title, isRequired } = props;
    const classes = useStyles({});

    if (
        leadJobQualifications == null ||
        (isRequired && leadJobQualifications.requiredCount < 1) ||
        (!isRequired && leadJobQualifications.preferredCount < 1)
    ) {
        return null;
    }

    return (
        <div>
            <Text variant="h5">{title}</Text>
            <div className={classes.qualificationList}>
                <div />
                <Text
                    style={{
                        justifySelf: "left",
                    }}
                    variant="body1"
                    className={classes.tableHeader}
                >
                    job
                </Text>
                <Text
                    variant="body1"
                    className={classes.tableHeader}
                    style={{
                        justifySelf: "left",
                    }}
                >
                    candidate
                </Text>
                <Line />
                {leadJobQualifications.leadEducationJobQualifications?.length >
                0
                    ? leadJobQualifications.leadEducationJobQualifications?.map(
                          x =>
                              x.educationJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.educationJobQualification.id}
                                  >
                                      <EducationQualification
                                          qual={
                                              leadJobQualifications
                                                  .leadEducationJobQualifications[0]
                                          }
                                      />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}
                {leadJobQualifications.leadCustomYesNoJobQualifications
                    ?.length > 0
                    ? leadJobQualifications.leadCustomYesNoJobQualifications?.map(
                          x =>
                              x.customYesNoJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.customYesNoJobQualification.id}
                                  >
                                      <CustomYesNoQualification qual={x} />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}

                {leadJobQualifications.leadCustomTextJobQualifications?.length >
                0
                    ? leadJobQualifications.leadCustomTextJobQualifications?.map(
                          x =>
                              x.customTextJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.customTextJobQualification.id}
                                  >
                                      <CustomTextQualification qual={x} />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}

                {leadJobQualifications.leadSkillJobQualifications?.length > 0
                    ? leadJobQualifications.leadSkillJobQualifications?.map(
                          x =>
                              x.skillJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.skillJobQualification.id}
                                  >
                                      <SkillJobQualification
                                          qual={x}
                                          isAnyOf={false}
                                      />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}

                {leadJobQualifications.leadSkillAnyOfJobQualifications?.length >
                0
                    ? leadJobQualifications.leadSkillAnyOfJobQualifications?.map(
                          x =>
                              x.skillJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.skillJobQualification.id}
                                  >
                                      <SkillJobQualification
                                          qual={x}
                                          isAnyOf={true}
                                      />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}


                {leadJobQualifications.leadLicenseJobQualifications?.length > 0
                    ? leadJobQualifications.leadLicenseJobQualifications?.map(
                          x =>
                              x.licenseJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.licenseJobQualification.id}
                                  >
                                      <LicenseQualification
                                          qual={x}
                                          isAnyOf={false}
                                      />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}
                {leadJobQualifications.leadLicenseAnyOfJobQualifications
                    ?.length > 0
                    ? leadJobQualifications.leadLicenseAnyOfJobQualifications?.map(
                          x =>
                              x.licenseJobQualification.isRequired ===
                                  isRequired && (
                                  <React.Fragment
                                      key={x.licenseJobQualification.id}
                                  >
                                      <LicenseQualification
                                          qual={x}
                                          isAnyOf={true}
                                      />
                                      <Line />
                                  </React.Fragment>
                              )
                      )
                    : null}
            </div>
        </div>
    );
};

//education

const getEducationAnswerDisplay = (
    leadQual?: LeadEducationJobQualification
) => {
    const degreeSuffixRequired =
        leadQual.answerEducationChoiceTagId !=
        EducationJobTag.HighSchoolOrEquivalent.id
            ? " degree"
            : "";

    return leadQual?.answerIsSatisfied === null
        ? "---"
        : leadQual.answerEducationChoiceText + degreeSuffixRequired;
};

const getEducationRequirementDisplay = (qual?: EducationJobQualification) => {
    const { education } = qual;
    if (!education) return "---";

    if (!education.educationChoiceTagName) return "None";

    if (
        education.educationChoiceTagId ===
        EducationJobTag.HighSchoolOrEquivalent.id
    )
        return education.educationChoiceTagName;

    return education.educationChoiceTagName + " degree";
};

const EducationQualification = (props: {
    qual: domain.LeadEducationJobQualification;
}) => {
    const {
        educationChoiceTagId,
        educationChoiceTagName,
    } = props.qual.educationJobQualification.education;

    const classes = useStyles({});
    return (
        <>
            <QualificationMetOrNot
                requirement={props.qual.answerJobQualificationRequirement}
            />
            <Text variant="body1" className={classes.requirementText}>
                {getEducationRequirementDisplay(
                    props.qual.educationJobQualification
                )}
            </Text>
            <Text variant="body1" className={classes.answerText}>
                {getEducationAnswerDisplay(props.qual)}
            </Text>
        </>
    );
};

//custom yes no

const CustomYesNoQualification = (props: {
    qual: domain.LeadCustomYesNoJobQualification;
}) => {
    const { qual } = props;

    const classes = useStyles({});
    return (
        <>
            <QualificationMetOrNot
                requirement={qual.answerJobQualificationRequirement}
            />
            <Text variant="body1" className={classes.requirementText}>
                {qual.customYesNoJobQualification.customText}
            </Text>
            <Text variant="body1" className={classes.answerText}>
                {qual.answerYesNoChoiceText ?? "---"}
            </Text>
        </>
    );
};

//custom text

const CustomTextQualification = (props: {
    qual: domain.LeadCustomTextJobQualification;
}) => {
    const { qual } = props;

    const classes = useStyles({});
    return (
        <>
            <QualificationMetOrNot
                requirement={qual.answerJobQualificationRequirement}
            />
            <Text variant="body1">
                {qual.customTextJobQualification.customText}
            </Text>
            <Text variant="body1" className={classes.answerText} preserveFormat>
                {qual.answerCustomText ?? "---"}
            </Text>
        </>
    );
};


//license

const getLicenseAnswerText = (license: domain.LeadLicenseAnswer) =>
    license.answerIsSatisfied == null
        ? "---"
        : license.answerIsSatisfied
        ? "yes"
        : "no";

const LicenseQualification = (props: {
    qual: domain.LeadLicenseJobQualification;
    isAnyOf: boolean;
}) => {
    const { qual } = props;
    const classes = useStyles({});
    const anyOrAll = props.isAnyOf ? "ANY" : "ALL";

    return (
        <>
            <QualificationMetOrNot
                requirement={qual.answerJobQualificationRequirement}
            />
            {qual.answerLicenses.length > 1 ? (
                <>
                    <Text variant="body1" className={classes.requirementText}>
                        {anyOrAll} of the following valid
                        licenses/certifications:{" "}
                    </Text>
                </>
            ) : qual.answerLicenses.length <= 1 ? (
                <Text variant="body1" className={classes.requirementText}>
                    {props.qual.answerLicenses.map(licenseAnswer => (
                        <React.Fragment key={licenseAnswer.licenseChoiceId}>
                            <Text variant="body1">
                                {licenseAnswer.stateTagName
                                    ? `${licenseAnswer.licenseChoiceText} in ${licenseAnswer.stateTagName}`
                                    : `${licenseAnswer.licenseChoiceText}`}
                            </Text>
                        </React.Fragment>
                    ))}
                </Text>
            ) : (
                ""
            )}

            {props.qual.answerLicenses.length > 1 ? (
                <div className={classes.answerList}>
                    {props.qual.answerLicenses.map(license => (
                        <React.Fragment key={license.licenseChoiceId}>
                            <Text variant="body1">
                                {license.stateTagName
                                    ? `${license.licenseChoiceText} in ${license.stateTagName}`
                                    : `${license.licenseChoiceText}`}
                            </Text>
                            <Text
                                variant="body1"
                                className={classes.multiAnswerText}
                            >
                                {getLicenseAnswerText(license)}
                            </Text>
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                props.qual.answerLicenses.map(license => (
                    <Text variant="body1" className={classes.multiAnswerText}>
                        {getLicenseAnswerText(license)}
                    </Text>
                ))
            )}
        </>
    );
};

const getSkillAnswerDescription = (answerSkill: domain.LeadSkillAnswer) => {
    if (answerSkill.answerIsSatisfied === null) return "---";

    if (!answerSkill.answerYearsOfExperienceTagName) return "0 years";

    return answerSkill.answerYearsOfExperienceTagName;
};

const SkillJobQualification = (props: {
    qual: domain.LeadSkillJobQualification;
    isAnyOf: boolean;
}) => {
    const classes = useStyles({});
    const anyOrAll = props.isAnyOf ? "ANY" : "ALL";

    return (
        <>
            <QualificationMetOrNot
                requirement={props.qual.answerJobQualificationRequirement}
            />
            <Text variant="body1" className={classes.requirementText}>
                {props.qual.answerSkills.length <= 1
                    ? props.qual.answerSkills.map(skillAnswer => (
                          <React.Fragment key={skillAnswer.answerSkillId}>
                              <Text variant="body1">
                                  {skillAnswer.skillChoiceText} (
                                  {skillAnswer.yearsOfExperienceTagName})
                              </Text>
                          </React.Fragment>
                      ))
                    : `${props.qual.skillJobQualification.yearsExperience.value}+
                    years of experience in ${anyOrAll} of the following:`}
            </Text>
            {props.qual.answerSkills.length > 1 ? ( // more than one, we still need to list the JQChoices
                <div className={classes.answerList}>
                    {" "}
                    {props.qual.answerSkills.map(skillAnswer => (
                        <React.Fragment key={skillAnswer.skillChoiceId}>
                            <Text variant="body1">
                                {skillAnswer.skillChoiceText}
                            </Text>
                            <Text
                                variant="body1"
                                className={classes.multiAnswerText}
                            >
                                {getSkillAnswerDescription(skillAnswer)}
                            </Text>
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                <Text variant="body1" className={classes.answerText}>
                    {getSkillAnswerDescription(props.qual.answerSkills[0])}
                </Text>
            )}{" "}
        </>
    );
};
